import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { invalidateContactsAndWorkforces } from "src/utils";
import { fetchBenefits } from "../../../permissions/benefits/redux/benefits.thunks";
import { AppDispatch } from "../../../redux/store";
import { deleteWorkforce } from "../actions/delete-workforce.actions";

export const useWorkforceDeleteMutation = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch<AppDispatch>();

  return useMutation({
    mutationFn: (workforceId: string) => deleteWorkforce(workforceId),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ["workforces"] });
      queryClient.invalidateQueries({ queryKey: ["total-workforce"] });
      await invalidateContactsAndWorkforces(queryClient);
      dispatch(fetchBenefits());
    },
  });
};
